// İSG uzmanı portalı — giriş noktası.
//
// Açılış sırası: (1) self-host font (Latin Extended-A: TR + DE), (2) i18n init
// (backend dil paketi + uygulama microcopy'si) TAMAMLANMADAN route render EDİLMEZ
// → ham i18n anahtarı ekrana sızmaz ([[feedback_i18n_key_runtime_path]]).

// IBM Plex Sans 400+600 (S33 Carbon, Slice 2) — Inter'in yerini alır: web-expert
// artık yalnız Carbon temasını görüyor (theme-carbon.css'in --font-sans'ı hep bu
// aileye çözülür), Inter'i de yüklemek gereksiz bir ağ isteği olurdu. Latin +
// Latin Extended-A tek dosyada birlikte gelir (TR ş/ğ/ı/İ + DE ä/ö/ü/ß) — ayrı alt
// küme import'u gerekmez (bkz. .storybook/preview.ts'in aynı deseni, Slice 1b).
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/600.css';
import './index.css';

import {
  configureApiBaseUrl,
  configureAuthStorage,
  configureCultureStorage,
  hydrateAuthStore,
  i18next,
  initI18n,
  webIdbAuthStorage,
  webLocalCultureStorage,
} from '@isgportal/shared';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { appResources } from './i18n/locales';
import { queryClient } from './lib/queryClient';
import { router } from './router';

async function bootstrap() {
  // Platform enjeksiyonu (herhangi bir istekten/hydrate'ten ÖNCE): web idb +
  // localStorage adaptörleri + config-driven API taban adresi (Vite env).
  configureApiBaseUrl(import.meta.env.VITE_API_BASE_URL);
  configureAuthStorage(webIdbAuthStorage);
  configureCultureStorage(webLocalCultureStorage);
  await hydrateAuthStore();

  await initI18n(appResources);

  // `document.title` aktif dile göre (S33-8 review fix #9) — `index.html`'in statik başlığı
  // yalnız JS-öncesi düşüş; ilk değer burada + her dil değişiminde `app.title` ile ezilir.
  const applyDocumentTitle = () => {
    document.title = i18next.t('app.title');
  };
  applyDocumentTitle();
  i18next.on('languageChanged', applyDocumentTitle);

  const container = document.getElementById('root');
  if (!container) {
    throw new Error('Kök öğe (#root) bulunamadı.');
  }

  createRoot(container).render(
    <StrictMode>
      <I18nextProvider i18n={i18next}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </I18nextProvider>
    </StrictMode>,
  );
}

void bootstrap();
